import { apiGet, apiPost } from '../client';
import type { ConsentStatus, PrivacyNotice } from '@/types/api';

/** Public — readable before an account exists. */
export function fetchPrivacyNotice(): Promise<PrivacyNotice> {
  return apiGet<PrivacyNotice>('/privacy/notice', { anonymous: true });
}

export function fetchConsent(): Promise<ConsentStatus> {
  return apiGet<ConsentStatus>('/privacy/consent');
}

export function acceptNotice(): Promise<ConsentStatus> {
  return apiPost<ConsentStatus>('/privacy/consent');
}

/** Unlinks the caller's devices: crash alerts for them stop. */
export function withdrawConsent(): Promise<ConsentStatus & { devices_unlinked: number }> {
  return apiPost('/privacy/consent/withdraw');
}

/** POST rather than GET so the password confirmation never sits in a URL. */
export function exportMyData(password: string): Promise<unknown> {
  return apiPost<unknown>('/privacy/export', { body: { password } });
}

export function eraseMyAccount(password: string): Promise<{ erased: boolean }> {
  return apiPost<{ erased: boolean }>('/privacy/erase', { body: { password } });
}
